import { Row, Col, Table, Button, Radio, Tooltip, Input } from "antd";

import logo from "../assets/images/logo-payap-bule.png";
import "antd/dist/antd.css";
import React, { Component } from "react";

import * as _ from "lodash"; //
import moment from "moment";

import "../App.css"

function EvalutionHeader() {
  const language = localStorage.getItem("Language")
  console.log('language', language)
  return (
    <div style={{ margin: 50, marginTop: 25 }}>
          {language == 'TH' ?
          <div>
             <h3> 
              แบบฟอร์มประเมินผลการปฎิบัติงานของบุคลากรมหาวิทยาลัยพายัพ
              ประจำปีการศึกษา 2564
            </h3>
          </div> :
          <div>  
            <h3>
              Performance Evaluation of Payap University for
              the 2021 Academic Year
            </h3>
          </div>
      
          }

          <Row>
            {language == 'TH' ?
              <Col span={12}>
                <p>

                  <b>ชื่อ - สกุล </b>
                  {" " + localStorage.getItem("TitleTH") +
                    localStorage.getItem("FirstNameTH") +
                    " " +
                    localStorage.getItem("LastNameTH")}

                </p>
                <p>
                  <b>รหัสบุคลากร</b> {localStorage.getItem("EmpId")}
                </p>
                <p>
                  <b>สถานะ</b> {localStorage.getItem("GroupPositionNAME")}
                </p>
                {/* <p>
                  <b>วันเริ่มเข้างาน</b>{" "}
                  { " " + moment(localStorage.getItem("StartJob")).format("DD/MM/YYYY") }
                </p> */}
              </Col>
              : <Col span={12}>
                <p>

                  <b>Firstname - Lastname </b>
                  {" " + localStorage.getItem("TitleEN") + " "+
                    localStorage.getItem("FirstNameEN") +
                    " " +
                    localStorage.getItem("LastNameEN")}

                </p>
                <p>
                  <b>Personnel Code</b> {localStorage.getItem("EmpId")}
                </p>
                <p>
                  <b>Status</b> {localStorage.getItem("GroupPositionNameEN")}
                </p>
                {/* <p>
                  <b>Start Date</b>
                  {" " +
                    moment(localStorage.getItem("StartJob")).format("DD/MM/YYYY")}
                </p> */}
              </Col>
            }
            {language == 'TH' ?
              <Col span={12}>
                <p>
                  <b>ตำแหน่ง</b> {localStorage.getItem("PositionNameTH")}
                </p>
                <p>
                  <b>สังกัดฝ่าย</b> {localStorage.getItem("DepartmentTH")}
                </p>
              </Col> :
              <Col span={12}>
                <p>
                  <b>Position</b> {localStorage.getItem("PositionNameEN")}
                </p>
                <p>
                  <b>Department</b> {localStorage.getItem("DepartmentEN")}
                </p>
              </Col>
            }
          </Row>



    </div>
  );

}

export default EvalutionHeader;
